import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('SCHEMA_ERRORS.NAME_REQUIRED'),
  taxId: Yup.string().required('SCHEMA_ERRORS.TAX_ID_ERROR')
});
